/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ErrorReason {
    Unknown = 0,
    UnsupportedFileType = 1,
    EmptyFile = 2,
    InvalidSignature = 3,
    FileHashMismatch = 4,
    Duplicate = 5,
    PasswordProtectedRead = 6
}

export function ErrorReasonFromJSON(json: any): ErrorReason {
    return ErrorReasonFromJSONTyped(json, false);
}

export function ErrorReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorReason {
    return json as ErrorReason;
}

export function ErrorReasonToJSON(value?: ErrorReason | null): any {
    return value as any;
}

